const SKU_FREE_TRIAL = 'cr_premium.1_month';
const SKU_FAN_PACK_FREE_TRIAL = 'cr-fan-membership-freetrial-1';

export {SKU_FREE_TRIAL, SKU_FAN_PACK_FREE_TRIAL};
